module.exports = __webpack_public_path__ + "img/ND.4dd8673e.png";